import React from 'react'

const AnimatedCounter = (props) => {
    let animateClass = ''
    let animateStyle = {}
    const array = []
    for (let i = 0; i <= props.endNumber; i += 1) {
        if (i < 10 && props.endNumber > 9) {
            array.push(`0${i}`)
        } else {
            array.push(`${i}`)
        }
    }

    const items = array.map((val, key) => (
        <div key={key} className="animated-counter-inner__item">{val}</div>
    ))

    if (props.startAnimation) {
        animateStyle = {
            transitionDuration: `${props.transitionDuration}s`,
            WebkitTransitionDuration: `${props.transitionDuration}s`,
            MozTransitionDuration: `${props.transitionDuration}s`,
            msTransitionDuration: `${props.transitionDuration}s`,
            OTransitionDuration: `${props.transitionDuration}s`,
        }
        animateClass = 'animated-counter-inner1--animate'
    }

    return (
        <div className="animated-counter">
            <span className="animated-counter__fix">{props.prefix}</span>
            <div
                className={'animated-counter-inner '}
            >
                <div
                    className={`animated-counter-inner1 ${animateClass}`}
                    style={animateStyle}
                >
                    {items}
                </div>
            </div>
            <span className="animated-counter__fix">{props.sufix}</span>
        </div>
    )
}

AnimatedCounter.defaultProps = {
    endNumber: 0,
    transitionDuration: 0,
    startAnimation: false,
    prefix: '',
    sufix: ''
}

export default AnimatedCounter



// WEBPACK FOOTER //
// ./src/scripts/components/AnimatedCounter.jsx